/**
 * "1-slot overlap" — lets auto-assign hand a counter over with the outgoing and
 * incoming officer both on it for one 15-minute slot, when that mans more counters
 * without a break in service.
 *
 * Sits beside "Max ctr duration" in every header whose buttons trigger an automatic
 * assignment, and for the same reason: both are decisions the whole add is planned
 * against, so they read as one setting shown in several places. Unlike the duration
 * cap this one belongs to the session rather than the browser — everyone on the same
 * session ID plans against the same rule.
 */

import { useHandoffOverlap } from '@/utils/handoffOverlap';

export function HandoffOverlapToggle({ compact: _compact = false }: { compact?: boolean }) {
  const [value, setValue, saving] = useHandoffOverlap();

  return (
    <label
      title={
        'Let auto-assign hand a counter over with a 15-minute overlap — both officers on it '
        + 'for that slot — when it mans more counters with no break in service. Used only '
        + 'where it actually adds a running counter: a clean back-to-back handoff always wins.'
      }
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        background: value ? '#eef2ff' : '#f8fafc',
        border: `1px solid ${value ? '#c7d2fe' : '#e2e8f0'}`,
        borderRadius: 8,
        padding: '3px 8px',
        fontSize: 12,
        fontWeight: 700,
        color: value ? '#4338ca' : '#64748b',
        whiteSpace: 'normal',
        lineHeight: 1.25,
        cursor: saving ? 'progress' : 'pointer',
        opacity: saving ? 0.6 : 1,
      }}
    >
      <input
        type="checkbox"
        checked={value}
        disabled={saving}
        onChange={(e) => { void setValue(e.target.checked); }}
        aria-label="Allow up to 2 officers in a counter for 15 minutes if it makes the counter running"
        style={{ flexShrink: 0, accentColor: '#4338ca', cursor: saving ? 'progress' : 'pointer', margin: 0 }}
      />
      Allow up to 2 officers in a ctr for 15mins if it makes the ctr running
    </label>
  );
}
